import { Component, OnDestroy } from '@angular/core';
import { ClaimsSearchFacade } from '@cigna/chcp/claims/shared/data-access';

@Component({
  selector: 'cigna-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
})
export class PageComponent implements OnDestroy {
  constructor(private claimsSearchFacade: ClaimsSearchFacade) {}

  ngOnDestroy() {
    this.claimsSearchFacade.setIntialState();
  }
}
